import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { openConsentSettings } from "../utils/cookieConsent";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Script dynamisch laden
    const script = document.createElement("script");
    script.src = "/js/script.js"; // Pfad zur Datei anpassen, falls nötig
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Script entfernen, wenn Footer nicht mehr im DOM ist
      document.body.removeChild(script);
    };
  }, []);
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-copyright">{t("footer.copyright")}</p>
        <nav className="footer-links">
          <a href="/datenschutz">{t("footer.privacy")}</a>
          <a href="/impressum">{t("footer.imprint")}</a>
          <button type="button" onClick={openConsentSettings}>
            {t("footer.cookieSettings")}
          </button>
        </nav>
      </div>
      <div className="footer-iconTop">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <i className="bx bx-up-arrow-alt"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
